<script setup lang="ts">
import { services } from '~/components/services/exercise';

const text = 'Zde se potkává síla s odvahou.';
</script>

<template>
  <NavbarDropdownTab :title="text" :services />
</template>
